
  import * as storyblokRuntime$ovub6QR94BABtBmVRef1yDlNskBCItW_45z6eY0Dl2TFU from 'F:/Github/dexon-technology/frontend/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.11.1_magicast@0.5.5_srvx@0.11.22/node_modules/@nuxt/image/dist/runtime/providers/storyblok'
import * as ipxRuntime$k_yfrJgsFBGDV0hwk_H_KBlOWIhuPb5FSjlR_45vmDI_k from 'F:/Github/dexon-technology/frontend/node_modules/.pnpm/@nuxt+image@1.11.0_db0@0.3.4_ioredis@5.11.1_magicast@0.5.5_srvx@0.11.22/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['storyblok']: { provider: storyblokRuntime$ovub6QR94BABtBmVRef1yDlNskBCItW_45z6eY0Dl2TFU, defaults: {"baseURL":"https://a.storyblok.com"} },
  ['ipx']: { provider: ipxRuntime$k_yfrJgsFBGDV0hwk_H_KBlOWIhuPb5FSjlR_45vmDI_k, defaults: {} }
    }
  }
